// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");

function _responsive(xs, sm, md, lg, xl, xxl, param) {
  return {
    xs: xs,
    sm: sm,
    md: md,
    lg: lg,
    xl: xl,
    xxl: xxl
  };
}

function mapResponsive(f, x) {
  let match = x.VAL;
  return _responsive(Stdlib_Option.map(match[0], f), Stdlib_Option.map(match[1], f), Stdlib_Option.map(match[2], f), Stdlib_Option.map(match[3], f), Stdlib_Option.map(match[4], f), Stdlib_Option.map(match[5], f), undefined);
}

function make(xs, sm, md, lg, xl, xxl, param) {
  return {
    NAME: "responsive",
    VAL: [
      xs,
      sm,
      md,
      lg,
      xl,
      xxl
    ]
  };
}

exports._responsive = _responsive;
exports.mapResponsive = mapResponsive;
exports.make = make;
/* No side effect */
